.container {
  align-items: center;
  background: var(--theme-dark-blue);
  display: flex;
  justify-content: space-evenly;
  min-height: 42px;
  user-select: none;
}

.shadow {
  min-height: 42px;
}

@media (pointer: fine) {
  .container {
    bottom: 0;
    min-height: 42px;
    pointer-events: all;
    position: absolute;
    transform: translateY(105%);
    transition: transform 0.2s ease-in-out;
    width: 100%;
  }

  .shadow {
    background: rgb(0 0 0 / 80%);
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transition: opacity .2s ease-in-out;
    width: 100%;
  }

  *:hover>.shadow .container {
    transform: translateY(0%);
  }

  *:hover>.shadow {
    opacity: 1;
  }
}

.action {
  color: var(--theme-white);
  font-size: var(--font-size-6);
  opacity: 0.7;
  transition: opacity 0.3s ease-in-out;
}

.action:hover {
  cursor: pointer;
  opacity: 1;
}

.action svg {
  margin-right: var(--space-small);
}